module.exports = __webpack_public_path__ + "static/CT-da47ef0c3b3f838e8a27c191b00becc6.svg";